import React from 'react'
import { 
    CellsTitle, Cells, CellFooter, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips, Radio, CellHeader, Switch, Label, Input
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import { WKVisible } from '../../components/wk'
import { isMoney } from '../../utils'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelLectureEditPage.css'


class ChannelEditTitlePage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            // password, free, unfree
            selectedRadio: 'free',
            money: 0,
            isResell: false,
            resellPercent: 0,
            password: '',
            isChannelNeedMoney: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchData()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchData () {
        this.setState({ isPending: true })
        axios.get(`/api/lecture/${this.props.params.id}/edit_info`)
            .then(res => {
                const lecture = res.data.data.lecture
                let mode = this.getMode(lecture)
                this.setState({ 
                    selectedRadio: mode,
                    isResell: lecture.resell_enabled,
                    resellPercent: lecture.resell_percent,
                    money: lecture.money / 100,
                    isPending: false,
                    password: lecture.password,
                    isChannelNeedMoney: mode === 'payChannel' || res.data.data.channel.need_money,
                })
            })
        // axios.get(`/api/channel/${this.props.location.query.channel_id}/short_info`)
        //     .then(res => {
        //         this.setState({ 
        //             isChannelNeedMoney: res.data.data.channel.need_money,
        //             selectedRadio: 'payChannel',
        //         })
        //     })
    }
    getMode (lecture) {
        switch (lecture.lecture_type) {
            case 'password_lecture':
                return 'password'
            case 'pay_lecture':
                return 'unfree'
            case 'pay_channel':
                return 'payChannel'
            default:
                return 'free'
        }
    }
    bindValue (e, field) {
        const value = field === 'resellPercent' && e.target.value > 49 ? 49 : e.target.value
        this.setState({ [field]: value })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    verify (money, resellPercent) {
        if (!isMoney(money)) {
            return {
                status: false,
                msg: '请输入正确的价格',
            }
        }
        if (money < 0.01 || money > 20000) {
            return {
                status: false,
                msg: '专栏售价应在0.01 - 20000之间',
            }
        }
        if (this.state.isResell) {
            if (!/^\d+$/.test(resellPercent) || (resellPercent < 0 || resellPercent > 100)) {
                return {
                    status: false,
                    msg: '比例为0到100的整数',
                }
            }
            if (money * resellPercent / 100 < 0.01) {
                return {
                    status: false,
                    msg: '价格*分成比例必须大于或等于0.01',
                }
            }
        }
        return { status: true }
    }
    onSubmit (e) {
        let submitData = {}
        if (this.state.selectedRadio === 'free') {
            submitData = {
                need_money: false,
                need_password: false,
                need_pay_channel: false,
            }
        }
        if (this.state.selectedRadio === 'unfree') {
            const verifyRes = this.verify(this.state.money, this.state.resellPercent)
            if (!verifyRes.status) return this.showTip(verifyRes.msg)
            submitData = {
                need_money: true,
                money: (this.state.money * 100).toFixed(0),
                resell_enabled: this.state.isResell,
                resell_percent: this.state.isResell ? this.state.resellPercent : 0,
            }
        }
        if (this.state.selectedRadio === 'password') {
            const reg = /^[0-9]\d*|0$/;
            if(!this.state.password.match(reg) || this.state.password.indexOf('.') > -1) {
                return this.showTip('请输入0-9的纯数字作为密码')
            }
            // if (this.state.password.trim() === '') return this.showTip('请输入密码')
            submitData = {
                need_password: true,
                password: this.state.password
            }
        }
        if (this.state.selectedRadio === 'payChannel') {
            submitData = {
                need_pay_channel: true,
            }
        }
        this.setState({ isPending: true })
        axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify(submitData))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.showAlert('修改成功')
            })
    }
    onChangeRadio (e, value) {
        this.setState({ selectedRadio: value })
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-lecture-edit-page">
                    <div className="pay-page">
                        <Header title='付费选项' />
                        <Form className='margin-bottom' radio>
                            <FormCell radio>
                                <CellBody>免费</CellBody>
                                <CellFooter>
                                    <Radio 
                                        name="pay" 
                                        checked={this.state.selectedRadio === 'free'} 
                                        onChange={e => this.onChangeRadio(e, 'free')} 
                                    />
                                </CellFooter>
                            </FormCell>
                            <FormCell radio>
                                <CellBody>付费课程</CellBody>
                                <CellFooter>
                                    <Radio 
                                        name="pay" 
                                        checked={this.state.selectedRadio === 'unfree'} 
                                        onChange={e => this.onChangeRadio(e, 'unfree')} 
                                    />
                                </CellFooter>
                            </FormCell>
                            <FormCell radio>
                                <CellBody>加密课程</CellBody>
                                <CellFooter>
                                    <Radio 
                                        name="pay" 
                                        checked={this.state.selectedRadio === 'password'} 
                                        onChange={e => this.onChangeRadio(e, 'password')} 
                                    />
                                </CellFooter>
                            </FormCell>
                            {
                                this.state.isChannelNeedMoney && <FormCell radio>
                                    <CellBody>必须购买专栏</CellBody>
                                    <CellFooter>
                                        <Radio 
                                            name="pay" 
                                            checked={this.state.selectedRadio === 'payChannel'} 
                                            onChange={e => this.onChangeRadio(e, 'payChannel')} 
                                        />
                                    </CellFooter>
                                </FormCell>
                            }
                        </Form>
                        <WKVisible create={this.state.isChannelNeedMoney}>
                            <p className="intro" style={{paddingTop: 0}}>"必须购买专栏"的直播课程没有单课价格，用户购买专栏前不能访问单课介绍页，可以不编辑单课介绍，专注优化专栏介绍页</p>
                        </WKVisible>
                        {/* 下面是按需显示的组件 */}
                        <WKVisible show={this.state.selectedRadio === 'password'} className='margin-bottom'>
                            <Form>
                                <FormCell>
                                    <CellHeader>
                                        <Label>密码</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            onChange={e => this.bindValue(e, 'password')} 
                                            type="number"
                                            pattern="[0-9]*"
                                            placeholder="请输入密码"
                                            value={this.state.password}
                                        />
                                    </CellBody>
                                </FormCell>
                            </Form>
                            <p className="intro">仅限数字</p>
                        </WKVisible>

                        <WKVisible show={this.state.selectedRadio === 'unfree'}>
                            <Form>
                                <FormCell>
                                    <CellHeader>
                                        <Label>价格（元）</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            onChange={e => this.bindValue(e, 'money')} 
                                            type="number"
                                            placeholder="请输入价格"
                                            value={this.state.money}
                                        />
                                    </CellBody>
                                </FormCell>
                                <FormCell switch>
                                    <CellBody>设置邀请奖励</CellBody>
                                    <CellFooter>
                                        <Switch 
                                            checked={this.state.isResell} 
                                            onChange={e => this.setState({ isResell: e.target.checked })} 
                                        />
                                    </CellFooter>
                                </FormCell>
                                <WKVisible create={this.state.isResell} tag={null}>
                                    <FormCell>
                                        <CellHeader>
                                            <Label>分成比例（%）</Label>
                                        </CellHeader>
                                        <CellBody>
                                            <Input 
                                                value={this.state.resellPercent}
                                                onChange={e => this.bindValue(e, 'resellPercent')} 
                                                type="number" 
                                                pattern='[0-9]*'
                                                placeholder="输入1～49的整数作为邀请奖励分成"
                                                disabled={!this.state.isResell}
                                            />
                                        </CellBody>
                                    </FormCell>
                                </WKVisible>
                            </Form>
                        </WKVisible>
                        <WKVisible show={this.state.selectedRadio === 'unfree'}>
                            <p className="intro">邀请奖励可以刺激用户分享给好友</p>
                        </WKVisible>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit(e)}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: 'Ok', onClick: () => browserHistory.go(-1) }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default ChannelEditTitlePage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditPayPage.js